module.exports = __webpack_public_path__ + "img/ruler.f6b68e80.svg";